import { render } from "./Pagination.vue?vue&type=template&id=252c36d5&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=252c36d5&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252c36d5"]])

export default __exports__